/****************************************************
 * Module Name:  remarkModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useEffect, useState } from "react";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, Container } from "@mui/material";
import renderCellExpand from "../common/dataGridCellExpand";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";
import logo from '../../images/pansuriya.jpg'
import "./../../style/modalstyle.css";
import Utility from "../../utility/utility";

const RemarkModal = ({ sourceData, handleClose, show }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        getdata()
    }, [])

    const getdata = () => {
        let x = Utility.GetRemark(sourceData)
        setData(x)
    }

    const columnName = [
        {
            field: "category",
            headerName: "CATEGORY",
            headerAlign: "center",
            align: "center",
            minWidth: 50,
            flex: 1
        },
        {
            field: "remark",
            headerName: "REMARK",
            headerAlign: "center",
            align: "center",
            minWidth: 230,
            flex: 1,
            renderCell: renderCellExpand,
        },
    ];

    const rows = data;
    const columns = columnName;
    return (
        <div>
            <Modal show={show} onHide={handleClose} dialogClassName="bhb" enforceFocus={false}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Remarks
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box
                        style={{
                            textAlign: "center",
                            fontSize: "xx-large",
                            marginTop: "0.5rem",
                            width: "100%",
                        }}
                    >
                        Remarks
                    </Box>
                    <Container maxWidth="xxl">
                        <Box
                            sx={{
                                backgroundColor: '#fff',
                                color: '#000',
                                width: "100%",
                                position: "relative",
                                "& .MuiTablePagination-selectLabel": {
                                    marginTop: "15px",
                                },
                                "& .MuiTablePagination-displayedRows": {
                                    marginTop: "15px",
                                },
                                "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-1knaqv7-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "4px 5px",
                                    borderRadius: "4px",
                                },
                                "& .css-cc8tf1": {
                                    fontWeight: Constants.defaultFontWeight,
                                },
                                "& .css-znmrd6-MuiButtonBase-root-MuiButton-root": {
                                    color: "#1976d2",
                                    padding: "5px 5px",
                                    borderRadius: "4px",
                                },
                                height: "50vh",
                            }}
                        >
                            <DataGridPro
                                disableRowSelectionOnClick={true}
                                getRowHeight={() => "auto"}
                                sx={{
                                    '& .MuiDataGrid-columnHeader': {
                                        color: '#fff',
                                        backgroundColor: 'grey',
                                    },
                                    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                                        py: "8px",
                                    },
                                    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                                        py: "15px",
                                    },
                                    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                                        py: "22px",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                                        width: "0.4em",
                                        height: "0.7em",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
                                        background: "#f1f1f1",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
                                        backgroundColor: "#888",
                                    },
                                    "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover": {
                                        background: "#555",
                                    },

                                    fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                                }}
                                density="compact"
                                slots={{ toolbar: GridToolbar }}
                                rows={rows}
                                columns={columns}

                                getRowId={(row) => row.id}
                                initialState={{
                                    columns: {
                                        columnVisibilityModel: {
                                            // Hide columns id, the other columns will remain visible
                                            // id: false,
                                        },
                                    },
                                    sorting: {
                                        sortModel: [{ field: "id", sort: "asc" }],
                                    },
                                    pagination: {
                                        paginationModel: Constants.pageSize,
                                    },
                                }}
                                pageSizeOptions={Constants.pageSizeOptions}
                                pagination
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 },
                                    },
                                }}
                            />
                        </Box>

                    </Container>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" color="error" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default RemarkModal;
